import { Component, OnInit, Input, DoCheck, Optional, NgZone, ElementRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { MapAutoCompleteOptions } from '../../Shared/Models/MapAutoCompleteOptions';
import { MapAutocompleteDTO } from '../../Shared/Models/MapAutocompleteDTO';
import { Title } from '@angular/platform-browser';
import { Location, Appearance, GermanAddress, MatGoogleMapsAutocompleteComponent } from '@angular-material-extensions/google-maps-autocomplete';
import PlaceResult = google.maps.places.PlaceResult;
import { MapsAPILoader, LazyMapsAPILoader } from '@agm/core';
import { WindowRef, DocumentRef } from '@agm/core/utils/browser-globals';
@Component({
  selector: 'BBSF-MapAutoComplete',
  templateUrl: './MapAutoComplete.component.html',
  styleUrls: ['./MapAutoComplete.component.scss']
})
export class MapAutoCompleteComponent implements OnInit {


  static controlContainerstatic = null;
  constructor(private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone, private titleService: Title, private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public MapAutoCompleteControlHost: FormGroupDirective) {
    MapAutoCompleteComponent.controlContainerstatic = this.controlContainer;
    this.CurrentLanguage = UtilityService.Translator.currentLang != undefined ? UtilityService.Translator.currentLang : UtilityService.Translator.defaultLang

  }
  @Input() group: FormGroup;
  @Input() options: MapAutoCompleteOptions;
  @Output() OnChange = new EventEmitter();

  MapAutoCompleteFormControl: AbstractControl;
  MapAutoCompleteModel: MapAutocompleteDTO=new MapAutocompleteDTO();
  CurrentLanguage: string = "";
  onAutocompleteSelected = new EventEmitter();
  onGermanAddressMapped = new EventEmitter();
  onLocationSelected = new EventEmitter();
  @ViewChild("search", {static:true,read:null})
  public searchElementRef: ElementRef;
  MatGoogleMapsAutocompleteComponent: MatGoogleMapsAutocompleteComponent
  LazyMapsAPILoader: LazyMapsAPILoader
  markAllAsTouched:boolean=false;
  validationRules = [];
  validationRulesasync = [];
  ngOnInit() {
    UtilityService.isCreatedBefor = false

    this.MapAutoCompleteModel= new MapAutocompleteDTO();
    UtilityService.Translator.onLangChange.subscribe((event) => {
      this.CurrentLanguage = event.lang;
      ;
      if (this.CurrentLanguage == 'ar')
        this.mapsAPILoader["_config"]["localeId"] = "ar-EG";
      if (this.CurrentLanguage == 'en')
        this.mapsAPILoader["_config"]["localeId"] = "en-US";
      this.mapsAPILoader["_scriptLoadingPromise"] = null
      this.mapsAPILoader["_config"]["apiKey"] = `AIzaSyDaqLzsDywi8RgZNDd1sFqOzRFWHr-ZSWM&language=${this.CurrentLanguage}`;
      var ScriptTag = document.getElementById(this.mapsAPILoader["_SCRIPT_ID"]);
      if (ScriptTag)
        ScriptTag.remove();
      var elements = document.getElementsByClassName("pac-container");
      while (elements.length > 0)
        elements[0].remove();

      let window = this.mapsAPILoader["_windowRef"].getNativeWindow();
      window.google = null



      this.LazyMapsAPILoader = new LazyMapsAPILoader({
        // &language=${UtilityService.CurrentLanguage}
        apiKey: `AIzaSyDaqLzsDywi8RgZNDd1sFqOzRFWHr-ZSWM&language=${this.CurrentLanguage}`,
        libraries: ['places'],
      }, this.mapsAPILoader["_windowRef"], this.mapsAPILoader["_documentRef"], this.mapsAPILoader["_config"]["localeId"]);
      this.LazyMapsAPILoader.load().then(() => {
        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: ["address"]

        });
        autocomplete.addListener('place_changed', (/**
                * @return {?}
                */
          () => {

            this.ngZone.run((/**
                    * @return {?}
                    */
              () => {
                // get the place result
                /** @type {?} */
                const place = autocomplete.getPlace();
                /** @type {?} */
                const germanAddress = {
                  gmID: place.id,
                  icon: place.icon,
                  url: place.url,
                  placeID: place.place_id,
                  displayAddress: place.formatted_address,
                  name: place.name,
                  vicinity: place.vicinity,
                  locality: {},
                  state: {},
                  country: {},
                  geoLocation: { latitude: -1, longitude: -1 },
                };

                if (place.geometry && place.geometry.location) {
                  germanAddress.geoLocation.latitude = place.geometry.location.lat();
                  germanAddress.geoLocation.longitude = place.geometry.location.lng();
                }
                place.address_components.forEach((/**
                        * @param {?} value
                        * @return {?}
                        */
                  value => {
                    if (value.types.indexOf('street_number') > -1) {
                      germanAddress["streetNumber"] = value.short_name;
                    }
                    if (value.types.indexOf('route') > -1) {
                      germanAddress["streetName"] = value.long_name;
                    }
                    if (value.types.indexOf('postal_code') > -1) {
                      germanAddress["postalCode"] = Number(value.short_name);
                    }
                    if (value.types.indexOf('sublocality') > -1) {
                      germanAddress["sublocality"] = value.long_name;
                    }
                    if (value.types.indexOf('locality') > -1) {
                      germanAddress.locality["long"] = value.long_name;
                      germanAddress.locality["short"] = value.short_name;
                    }
                    if (value.types.indexOf('administrative_area_level_1') > -1) {
                      germanAddress.state["long"] = value.long_name;
                      germanAddress.state["short"] = value.short_name;
                    }
                    if (value.types.indexOf('country') > -1) {
                      germanAddress.country["long"] = value.long_name;
                      germanAddress.country["short"] = value.short_name;
                    }
                    if (value.types.indexOf('administrative_area_level_3') > -1) {
                      germanAddress.locality["short"] = value.short_name;
                    }
                  }));
                
                this.onGermanAddressMapped.emit(germanAddress);
                this.GermanAddressMapped(germanAddress)
                if (!place.place_id || place.geometry === undefined || place.geometry === null) {
                  // place result is not valid
                  return;
                }
                else {
                  // show dialog to select a address from the input
                  // emit failed event
                }
                //   this.address = place.formatted_address;
                this.onAutocompleteSelected.emit(place);
                this.AutocompleteSelected(place)

                this.onLocationSelected.emit({
                  latitude: place.geometry.location.lat(),
                  longitude: place.geometry.location.lng()
                });
              }));
          }));
      });

    });


    ;
    if (this.CurrentLanguage == 'ar')
      this.mapsAPILoader["_config"]["localeId"] = "ar-EG";
    if (this.CurrentLanguage == 'en')
      this.mapsAPILoader["_config"]["localeId"] = "en-US";
    this.mapsAPILoader["_scriptLoadingPromise"] = null
    this.mapsAPILoader["_config"]["apiKey"] = `AIzaSyDaqLzsDywi8RgZNDd1sFqOzRFWHr-ZSWM&language=${this.CurrentLanguage}`;
    var leftSection = document.getElementById(this.mapsAPILoader["_SCRIPT_ID"]);
    if (leftSection)
      leftSection.remove();
    this.LazyMapsAPILoader = new LazyMapsAPILoader({
      apiKey: `AIzaSyDaqLzsDywi8RgZNDd1sFqOzRFWHr-ZSWM&language=${this.CurrentLanguage}`,
      libraries: ['places'],
    }, this.mapsAPILoader["_windowRef"], this.mapsAPILoader["_documentRef"], this.mapsAPILoader["_config"]["localeId"]);
    this.LazyMapsAPILoader.load();
    
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]

      });

    })
    this.group.addControl(this.options.Name, new FormControl(''));
    this.MapAutoCompleteFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);
    
    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    if(this.options.LabelKey!=null&&this.options.LabelKey!="")
    this.options.LabelValue= UtilityService.getResourceValue(this.options.LabelKey);

    this.MapAutoCompleteFormControl.setValidators(this.validationRules);
    this.MapAutoCompleteFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.MapAutoCompleteFormControl.disable();
    }
    if(this.options.Value != null)
    {
      this.MapAutoCompleteFormControl.setValue(this.options.Value);
    }

    if (this.options.CustomValidation.length > 0) 
    {
      let Validations=this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }
    
    }
    
    
    this.MapAutoCompleteControlHost.ngSubmit.subscribe((value)=>{
      this.group.markAllAsTouched()
      this.markAllAsTouched=true
    })


  }
  ngAfterViewInit() {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }
    }
  }
 
  resetError = () =>{
    UtilityService.RemoveGlobalError();
  }

  showGlobalError(){
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if(this.markAllAsTouched&&this.group.invalid)
    {
        this.showGlobalError()
        this.markAllAsTouched=false
    }
   
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
}

  AutocompleteSelected(result) {


    this.MapAutoCompleteModel == new MapAutocompleteDTO();
    this.MapAutoCompleteModel.Text = result.formatted_address;
    this.MapAutoCompleteModel.PlaceID = result.place_id;
    this.MapAutoCompleteModel.GoogleMapsURL = result.url;
  }
  LocationSelected(location) {

    this.MapAutoCompleteModel.Latitude = location.latitude;
    this.MapAutoCompleteModel.Longitude = location.longitude;
    this.MapAutoCompleteFormControl.setValue(null);

    this.MapAutoCompleteFormControl.setValue(this.MapAutoCompleteModel);
  }

  GermanAddressMapped(result) {
  
   
    this.MapAutoCompleteModel == new MapAutocompleteDTO();
    this.MapAutoCompleteModel.Text = result.displayAddress;
    this.MapAutoCompleteModel.PlaceID = result.placeID;
    this.MapAutoCompleteModel.GoogleMapsURL = result.url;
    this.MapAutoCompleteModel.Latitude = result.geoLocation.latitude;
    this.MapAutoCompleteModel.Longitude = result.geoLocation.longitude;
    this.MapAutoCompleteFormControl.setValue(this.MapAutoCompleteModel);
    this.OnChange.emit(this.MapAutoCompleteFormControl.value)
  }

    //External Method

  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.MapAutoCompleteFormControl, this.validationRules, this.options)
  }
    //External Method

  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.MapAutoCompleteFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.MapAutoCompleteFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.MapAutoCompleteFormControl, this.validationRules,CustomValidation)
  }

   //External Method
   IsValid = () => {
    this.controlUtility.IsValid(this.MapAutoCompleteFormControl)
  }
}


